<section class="coupons-page">
  <app-admin-page-header
    title="Cupons"
    subtitle="Crie, consulte e atualize os cupons da plataforma.">
    <button header-actions class="admin-btn admin-btn--primary" (click)="createCoupon()">
      Novo cupom
    </button>
  </app-admin-page-header>

  <div class="admin-feedback admin-feedback--error" *ngIf="feedbackError">
    {{ feedbackError }}
  </div>

  <div class="coupons-toolbar admin-surface">
    <input
      class="admin-input"
      type="text"
      [(ngModel)]="nameFilter"
      placeholder="Filtrar por nome"
      (keydown.enter)="onFilterChange()" />
    <select class="admin-input" [(ngModel)]="activeFilter" (change)="onFilterChange()">
      <option value="">Todos os cupons</option>
      <option value="true">Somente ativos</option>
      <option value="false">Somente inativos</option>
    </select>
    <input
      class="admin-input"
      type="number"
      min="1"
      [(ngModel)]="accountIdFilter"
      placeholder="Account ID vinculado"
      (keydown.enter)="onFilterChange()" />
    <label class="coupons-toolbar__checkbox">
      <input type="checkbox" [(ngModel)]="trustedOnlyFilter" (change)="onFilterChange()" />
      Somente trusted
    </label>
    <button class="admin-btn admin-btn--primary" (click)="onFilterChange()">Filtrar</button>
    <button class="admin-btn admin-btn--secondary" (click)="clearFilters()">Limpar</button>
  </div>

  <div class="coupons-selection" *ngIf="selectedCouponIds.size">
    <span>{{ selectedCouponIds.size }} cupom(ns) selecionado(s)</span>
    <button class="admin-btn admin-btn--primary" [disabled]="selectedCouponIds.size < 2" (click)="editSelectedCoupons()">
      Editar múltiplos cupons
    </button>
    <button class="admin-btn admin-btn--secondary" (click)="clearSelection()">Limpar seleção</button>
  </div>

  <div class="coupons-table admin-surface">
    <p-table
      [value]="coupons"
      [loading]="isLoading"
      [paginator]="true"
      [lazy]="true"
      [rows]="rowsPerPage"
      [totalRecords]="totalItems"
      (onLazyLoad)="onLazyLoad($event)">
      <ng-template pTemplate="header">
        <tr>
          <th><input type="checkbox" [checked]="allCurrentPageSelected" (change)="toggleCurrentPageSelection($any($event.target).checked)" /></th>
          <th>Nome</th>
          <th>Status</th>
          <th>Desconto</th>
          <th>Uso por usuário</th>
          <th>Exclusivo trusted</th>
          <th>Máximo de usos</th>
          <th>Vencimento</th>
          <th>Conta vinculada</th>
          <th>Ações</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-coupon>
        <tr>
          <td><input type="checkbox" [checked]="isCouponSelected(coupon.id)" (change)="toggleCouponSelection(coupon, $any($event.target).checked)" /></td>
          <td>{{ coupon.name }}</td>
          <td>{{ coupon.is_active ? 'Ativo' : 'Inativo' }}</td>
          <td>
            @if (coupon.percentage_discount) {
              {{ coupon.percentage_discount }} %
            } @else {
              R$ {{ coupon.fixed_discount }}
            }
          </td>
          <td>{{ coupon.one_time_use ? 'Único' : 'Ilimitado' }}</td>
          <td>{{ coupon.trusted_only ? 'Sim' : 'Não' }}</td>
          <td>{{ coupon.coupons_max_usage || 'Ilimitado' }}</td>
          <td>{{ coupon.expiration_datetime ? (coupon.expiration_datetime | date : 'dd/MM/yyyy HH:mm') : 'Sem vencimento' }}</td>
          <td>{{ coupon.account?.username || (coupon.account_id ? '#' + coupon.account_id : '-') }}</td>
          <td>
            <button class="admin-btn admin-btn--secondary" (click)="editCoupon(coupon.id)">
              Editar
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
